import { createAction } from '../../../store.model';
import { User } from '../../../user/user.model';
import { SearchType } from '../../core';
import { ActionType } from '../search.action';

export interface Reload {
    user?: User;
    searchType?: SearchType;
    dateRangeStart?: Date;
    dateRangeEnd?: Date;
}

export const reload = createAction<ActionType, Reload>(
    ActionType.EVAL_SEARCH__RELOAD,
);
